import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import excludeRouterKeys from './utilities/excludeRouterKeys';

const RaisedButtonLink = props => {
  const { to, router } = props;

  return (
    <RaisedButton
      {...excludeRouterKeys(props)}
      onClick={() => router.push(to)}
    />
  );
};

RaisedButtonLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(RaisedButtonLink);



// WEBPACK FOOTER //
// ./src/components/RaisedButtonLink.js